import React from 'react'

export default function Loader() {
  return (
    <div className="flex items-center justify-center h-screen bg-white">
      <video autoPlay loop muted playsInline width="100" height="100">
        <source src="/assets/loader.webm" type="video/webm" />
        Your browser does not support the video tag.
      </video>
    </div>
  )
}
